import NetworkError from "../../components/NetworkError";
import Preloader from "../../components/Preloader";
import 'react-confirm-alert/src/react-confirm-alert.css';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, useParams } from "react-router-dom";
import { useContext, useState } from "react";
import { config } from "../../constants/config";
import { useEffect } from "react";
import DomainInfos from "../../components/domains/domaininfo";
import NomensDomaine from "../../components/domains/nomensdomain";
import UserContext from "../../contexts/UserContext";



export default function ViewDomaine() {
    // states
    let codedomaine = useParams();
    const { user, logoutUser } = useContext(UserContext);
    const navigate = useNavigate();
    const [page, setPage] = useState(0);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    const [type, setType] = useState(0);
    const [nomtab, setNomtab] = useState("");
    const [nomtabparent, setNomtabparent] = useState("");
    const [libtitrevueliste, setLibtitrevueliste] = useState("");
    const [libtitrevuenouveau, setLibtitrevuenouveau] = useState("");
    const [libtitrevueedit, setLibtitrevueedit] = useState("");



    const getDomaine = async () => {
        setLoading(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.domain.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.domain.BASE_URL}/${config.domain.PROJECT}/domains/${codedomaine.code}`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let body = data?.body?.data[0];

                        setType(body?.type !== null ? body?.type : "");
                        setNomtab(body?.nomtab !== null ? body?.nomtab : "");
                        setNomtabparent(body?.nomtabparent ? body?.nomtabparent : "");
                        setLibtitrevueliste(body?.libtitrevuelist !== null ? body?.libtitrevuelist : "");
                        setLibtitrevuenouveau(body?.libtitrevuenouv !== null ? body?.libtitrevuenouv : "");
                        setLibtitrevueedit(body?.libtitrevueedit !== null ? body?.libtitrevueedit : "");

                        setLoading(false);
                    } else {
                        if (data?.body?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            setError(true);
                            setLoading(false);
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                setError(true);
                setLoading(false);
            }
        }).catch((err) => {
            // console.log("error", err);
            setError(true);
            setLoading(false);
        });
    }

    const displayPages = () => {
        if (page === 0) {
            return <DomainInfos codedomaine={codedomaine.code} />;
        } else {
            return <NomensDomaine nomtab={nomtab} type={type} parent={nomtabparent} list={libtitrevueliste} domain={codedomaine.code} />;
        }
        // else {
        //     return <EmployeeScans refid={refId} code={codeemploye.code}  />;
        // }
    }


    // comportements
    useEffect(() => {
        getDomaine();
    }, []);



    // affichages
    return (
        <>
            {loading && <Preloader />}
            {!loading && error && <NetworkError />}
            {!loading && !error && <div className="container-fluid">
                <h1 className="h4 mb-2 font-weight-bold text_primary">Domaines</h1>
                <div style={{ display: "flex", flexDirection: "row", justifyContent: "start", justifyItems: "center" }}>
                    <button onClick={() => { setPage(0) }} className={`btn-shadow rounded-0 btn ${page === 0 ? 'btn-primary' : 'btn-secondary'}`}>
                        <span>Informations du domaine</span>
                    </button>
                    <button onClick={() => { setPage(1) }} className={`btn-shadow rounded-0 btn ${page === 1 ? 'btn-primary' : 'btn-secondary'}`}>
                        <span>Nomenclatures du domaine</span>
                    </button>
                    {/* <button onClick={() => {setPage(2)}} className={`btn-shadow rounded-0 btn ${page === 2 ? 'btn-primary' : 'btn-secondary'}`}>
                                    <span>Employee access list</span>
                                </button> */}
                </div>
                {displayPages()}
            </div>}
        </>
    )
}